<script setup lang="ts">
const siteUrl = useSiteUrl()

import { computed, onMounted, onUnmounted, ref } from 'vue'

// import { ref, computed } from "vue";
// const props = defineProps<Props>()
// const blogUrl = computed(() => import.meta.env.VITE_BLOG_URL)

// const isExcludedRoute = computed(() => {
//   const excludedRoutes = ['/profile/requests/submitRequest']
//   return excludedRoutes.some(route =>
//     window.location.pathname.startsWith(route)
//   )
// })

// const isLoggedIn = computed(() => false)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isMobile = computed(() => false)
const { isLoggedIn } = useAuth()
// const articles = computed(() => [])
// const user = computed(() => null)
// const userIsVerified = computed(() => false)
// const userIsPendingForVerification = computed(() => false)
// const userIsPendingForRegistration = computed(() => false)

// const isBankAccountPage = computed(() => {
//   const bankAccountPages = [
//     'profile-bank-accounts',
//     'profile-bank-accounts-new',
//     'profile-destination-bank-accounts',
//     'profile-destination-currency-accounts'
//   ]
//   return bankAccountPages.includes(window.location.pathname)
// })

// const isDashboardPages = computed(() => {
//   const dashboardPages = ['profile-dashboard', 'profile-dashboard-discounts']
//   return dashboardPages.includes(window.location.pathname)
// })

// const goto = (refName: string) => {
//   isMenuOpen.value = false
//   window.scrollTo(100, refName as any)
//   window.location.href = '/'
// }

// const logout = () => {
//   console.log('Logout')
// }

// const onChildClosed = () => {
//   isMenuOpen.value = false
// }

const headerRef = ref<HTMLElement | null>(null)

const scroll = () => {
  try {
    const header = document.getElementById('header') || headerRef.value
    if (header === null) return
    if (window.scrollY > 10) {
      header?.classList.add('bg-white')
      header?.classList.toggle('absolute', false)
      header?.classList.toggle('fixed', true)
      header?.classList.toggle('shadow', true)
      header?.classList.toggle('top-0', true)
      header?.classList.toggle('left-0', true)
      header?.classList.toggle('right-0', true)
      header?.classList.toggle('z-[99]', true)
    } else {
      header?.classList.remove('bg-white')
      header?.classList.toggle('absolute', true)
      header?.classList.toggle('fixed', false)
      header?.classList.toggle('shadaw', false)
      header?.classList.toggle('top-0', false)
      header?.classList.toggle('left-0', false)
      header?.classList.toggle('right-0', false)
      header?.classList.toggle('z-[99]', false)
    }
  } catch (error) {
    console.error('Error in scroll function:', error)
  }
}
const handleScroll = () => {
  scroll()
}
onMounted(() => {
  if (typeof window === 'undefined') return
  scroll()
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  if (typeof window === 'undefined') return

  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <header>
    <div id="header" ref="headerRef" class="absolute top-0 z-[99] rtl w-full transition-colors duration-300 bg-none">
      <BaseContainer>
        <div class="flex justify-between items-center h-[65px] lg:h-[105px] px-6 lg:px-0">
          <!-- start of header -->
          <nav aria-label="منوی اصلی" class="flex items-center justify-between">
            <ul class="flex items-center justify-between">
              <ul>
                <nuxt-link to="/" class="ml-4 hidden lg:block">
                  <img src="@/assets/img/home/logo.svg" alt="لوگوی پی‌جیب" />
                </nuxt-link>
              </ul>
              <ul>
                <BaseMobileMenu class="block lg:hidden" />
              </ul>
              <ul>
                <nuxt-link to="/" class="mr-3 block lg:hidden">
                  <img src="@/assets/img/home/logo.svg" alt="لوگوی پی‌جیب" />
                </nuxt-link>
              </ul>

              <li>
                <button
                  class="relative group cursor-pointer hidden lg:flex items-center gap-1 font-normal text-sm px-3">
                  <span>خدمات پرداخت آنلاین</span>
                  <img src="/home/img/home/arrow-down.svg" alt="" aria-hidden="true" class="group-hover:rotate-180" />
                  <div
                    class="-ms-1 h-5 flex items-center gap-0.5 rounded-full bg-gradient-to-r from-[#315CFF] via-[#4B8DFF] to-[#6A5CFF] px-2 py-0 text-xs font-bold text-white shadow-[0_0_10px_rgba(76,108,255,0.35)]">
                    <!-- <span class="pt-0.5">✦</span> -->
                    <span>جدید</span>
                  </div>
                  <div class="absolute top-full pt-2 hidden group-hover:block w-full">
                    <ul class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 text-sm z-50 w-max">
                      <li>
                        <a id="btn-telegram" :href="siteUrl('/services/')" class="flex items-center gap-1 mb-4">
                          خدمات پرداخت بین‌المللی
                        </a>
                      </li>

                      <li>
                        <a id="btn-whatsapp" :href="siteUrl('/services/gift-cards')"
                          class="flex items-center gap-1 mb-4">
                          گیفت‌کارت
                        </a>
                      </li>

                      <li>
                        <a id="btn-whatsapp" :href="siteUrl('/services/custom')" class="flex items-center gap-1">
                          سفارش اختصاصی
                        </a>
                      </li>
                    </ul>
                  </div>
                </button>
              </li>

              <li>
                <a :href="siteUrl('/profile')" class="hidden lg:block text-sm font-medium px-3">
                  خدمات انتقال آنلاین
                </a>
              </li>
              <li>
                <button
                  class="relative group cursor-pointer hidden lg:flex items-center gap-1 font-normal text-sm px-3">
                  <span>پشتیبانی</span>
                  <img src="/home/img/home/arrow-down.svg" alt="" aria-hidden="true" class="group-hover:rotate-180" />
                  <div class="absolute top-full pt-2 hidden group-hover:block w-full">
                    <ul class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 text-sm z-50 w-max">
                      <li>
                        <a id="btn-telegram-header" href="https://t.me/+989360950650"
                          aria-label="تماس با پشتیبانی پی‌جیب در تلگرام" class="flex items-center gap-1 mb-4">
                          <img src="/home/img/telegram-2.svg" alt="" aria-hidden="true" />
                          تلگرام
                        </a>
                      </li>
                      <li>
                        <a id="btn-whatsapp-header" href="https://wa.me/989360950650"
                          aria-label="تماس با پشتیبانی پی‌جیب در واتساپ" class="flex items-center gap-1">
                          <img src="/home/img/whatsapp2.svg" alt="" aria-hidden="true" />
                          واتساپ
                        </a>
                      </li>
                    </ul>
                  </div>
                </button>
              </li>

              <li>
                <button
                  class="relative group cursor-pointer hidden lg:flex items-center gap-1 font-normal text-sm px-3">
                  <span>راهنما</span>
                  <img src="/home/img/home/arrow-down.svg" alt="" aria-hidden="true" class="group-hover:rotate-180" />
                  <div class="absolute top-full pt-2 hidden group-hover:block w-full">
                    <ul class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 text-sm z-50 w-max">
                      <li>
                        <NuxtLink to="/terms" id="btn-telegram" class="flex items-center gap-1 mb-4">
                          قوانین پی‌جیب
                        </NuxtLink>
                      </li>
                      <li>
                        <NuxtLink to="/#questions" class="flex items-center gap-1 mb-4">
                          سوالات متداول
                        </NuxtLink>
                      </li>
                      <li>
                        <NuxtLink to="/account-deletion" class="flex items-center gap-1">
                          حذف حساب کاربری
                        </NuxtLink>
                      </li>
                    </ul>
                  </div>
                </button>
              </li>

              <li>
                <a id="blog-btn" :href="siteUrl('/blog/')" class="hidden lg:block font-normal text-sm px-3">
                  وبلاگ
                </a>
              </li>
              <li>
                <NuxtLink to="/contact-us/" class="hidden lg:block font-normal text-sm px-3">
                  تماس با ما
                </NuxtLink>
              </li>
              <li>
                <NuxtLink to="/about/" class="hidden lg:block font-normal text-sm px-3">
                  درباره ما
                </NuxtLink>
              </li>
            </ul>
          </nav>
          <!-- end of header -->
          <div class="flex justify-start items-center gap-6">
            <!-- <ul v-if="user" class="user-info pa-0">
              <li class="d-flex text-center align-center">
                <span class="menu-item d-flex text-center align-center">
                  <span class="mobile-direction">
                    <i class="icon icon-arrow-down icon-20" />
                    <span class="username">{{ user.fullName }}</span>
                    <i class="icon icon-smile icon-20 mx-1" />
                  </span>
                  <ul>
                    <li>
                      <nuxt-link :to="{ name: 'profile' }"> پروفایل </nuxt-link>
                    </li>
                    <li>
                      <p class="mb-0" @click="logout">خروج</p>
                    </li>
                  </ul>
                </span>
              </li>
            </ul> -->

            <div class="flex justify-center items-center gap-2">
              <a v-if="isLoggedIn" :href="siteUrl('/profile/dashboard')"
                class="login-btn font-semibold border-primary border-2 rounded-[48px] flex items-center justify-center text-sm md:text-base px-3 md:px-4 h-[36px] md:h-[46px] text-primary whitespace-nowrap transition-all duration-300 hover:bg-primary hover:text-white hover:border-primary">
                ورود به پنل کاربری
              </a>
              <template v-else>
                <UiButton id="login-btn1" :href="siteUrl('/auth/login')"
                  class="login-btn text-sm lg:text-base h-[41px] font-bold" :link="true" :outlined="true"
                  :external="true">
                  ورود
                </UiButton>
                <UiButton id="register-btn" :href="siteUrl('/auth/register')"
                  class="login-btn text-sm lg:text-base h-[41px] font-bold text-nowrap" :link="true" :external="true">
                  ثبت نام
                </UiButton>
              </template>
            </div>
          </div>
        </div>
      </BaseContainer>
      <!-- <BaseBanner /> -->
    </div>

    <!-- Add the rest of your template here -->
  </header>
</template>

<style>
.active-item {
  border-bottom: 4px solid #ebedf0;
}

.shadaw {
  box-shadow: 10px 5px 4px rgba(0, 0, 0, 0.1);
}
</style>
